// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0a50349","396":"b617bae4","453":"3bc55ace","455":"234b95e1","977":"f5dddca7"}[chunkId] + ".chunk.js";
};